import cn from 'classnames';
import { handleActions } from '@chewy/chat-library-common';
import { ActionDef } from '@chewy/chat-library-common';
import { KibButtonNew } from '@chewy/kib-controls-react';
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css';
import styles from './ActionButton.module.scss';

export interface ActionButtonProps {
    action: ActionDef;
    widgetData?: Record<string, any>;
    className?: string;
}

export default function ActionButton({ action, widgetData, className }: ActionButtonProps) {

    const handleClick = () => {
        // Call handleActions from registry
        handleActions(action, widgetData);
    };

    return (
        <KibButtonNew
            onClick={handleClick}
            theme="action"
            size="medium"
            emphasis="secondary"
            className={cn(styles.actionButton, className)}
        >
            {action.text}
        </KibButtonNew>
    );
}
